import React, { useState } from 'react'
import { CustomModal } from '../../revampComponents/Atom/Modals';
import Dropdown from '../../revampComponents/Atom/Dropdown';
import Select from "react-select";
import warning from "../../assets/img/Models/warning.svg";
import FormButtons from '../../revampComponents/Molecule/Buttons/FormButtons';
import { successToaster, errorToaster, fetchValueForRoleId } from '../../reusable/common';
import { transferOwner } from '../../revampCRUD/organisers.crud';
import transferIconWhite from "../../assets/transfer-icon-white.svg"
import { dashboardColors, theme } from '../../themes/Theme';

const EditRole = ({
    setEditRole,
    editRole,
    eventId,
    adminData,
    listOrganizerDetails
}) => {
    const [loading, setLoading] = useState(false);
    const [roleId, setRoleId] = useState(adminData.role_id);

    const changeRoleApi = async () => {
        const payload = {
            role_id: roleId,
            user_email: adminData?.organiser_email,
        }
        setLoading(true);
        try {
            const getResponse = await transferOwner(eventId, payload);
            if (getResponse.status === 200) {
                successToaster(getResponse.data);
                setEditRole(false);
                listOrganizerDetails();
            } else {
                errorToaster("Something went wrong");
            }
        } catch (err) {
            errorToaster(err.message.error || "Something went wrong");
            setEditRole(false)
        }
        setLoading(false)
    }
    return (
        <>
            <CustomModal
                openModal={editRole}
                setOpenModal={setEditRole}
                saveBtnContent={null}
                width="35%"
                content={
                    <div className="px-3">
                        <>
                            <p className="title mb-2">
                                Edit Organizer role
                            </p>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <label style={{ color: "#1E1F24", fontWeight: "500", marginTop: "11px" }}>Email Id <span className="text-danger">*</span></label>
                                    <input
                                        className="mb-3 input"
                                        id="new_user_email"
                                        type="text"
                                        placeholder="Enter Email Id"
                                        value={adminData.organiser_email}
                                        disabled={true}
                                    />
                                    <label className="label" htmlFor="role">
                                        Role
                                        <span className="text-danger" style={{ fontWeight: 500 }}> *</span>
                                    </label>
                                    <Dropdown
                                        options={[
                                            {
                                                label: "Admin",
                                                value: 2
                                            },
                                            {
                                                label: "Admin (No Downloads)",
                                                value: 4
                                            }
                                        ]}
                                        id="role"
                                        defaultValue={fetchValueForRoleId(roleId)}
                                        value={fetchValueForRoleId(roleId)}
                                        onChange={e => {
                                            if (e.value == 2)
                                                setRoleId(2);
                                            else if (e.value === 4) {
                                                setRoleId(4);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                    <button
                                        className="save-btn"
                                        style={{ width: '100%' }}
                                        onClick={() => changeRoleApi()}
                                        disabled={roleId == '' || roleId === adminData.role_id || loading}
                                    >
                                        <span className="ml-2">Save and Send Email</span>
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                }
            />
            <style>{`
                .title{
                    font-family: Hind;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 500;
                    text-align: left;
                    color: ${dashboardColors[theme].primaryTextColor};
                }
            `}</style>
        </>
    )
}

export default EditRole
